export const LOGIN_PHRASES = [
  'Sabemos quién eres, pero... ¿lo eres? Mejor inicia sesión.',
  '¿Tú de nuevo? Sabíamos que volverías, inicia sesión.',
  'Ya sabes que hacer, correo y contraseña...',
  'Iniciar sesión, es como andar en bicicleta',
  'Donde hay Wi-Fi, hay inicio de sesión.',
  'Iniciar sesión o no iniciar, esa es la cuestión.'
]
